import type { Product } from '@montugroup/circuit-shared';

export const isProductInIntervalPreOrderState = (product: Pick<Product, 'intervalDetails'>) => {
  return product.intervalDetails?.estimatedIntervalState === 'PRE_ORDER';
};

export const isProductInIntervalLockedState = (product: Pick<Product, 'intervalDetails'>) => {
  return product.intervalDetails?.estimatedIntervalState === 'LOCKED';
};
